import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
dayjs.extend(isToday);
dayjs.extend(isYesterday);

dayjs.locale("de");

const $ = jQuery.noConflict();

const fromNow = function (d) {
  const now = dayjs();
  if (now.diff(d) < 0) return "Aus der Zukunft!";
  if (now.diff(d, "seconds") < 120) return "vor 1 Min.";
  const minutes = now.diff(d, "m");
  if (minutes < 60) return "vor %d Min.".replace("%d", minutes);
  if (d.isToday()) return d.format("HH:mm [Uhr]");
  if (d.isYesterday()) return d.format("[Gestern,] HH:mm [Uhr]");
  if (now.diff(d, "hours") < 7 * 24) return d.format("DD.MM.YY, HH:mm [Uhr]");

  return d.format("DD.MM.YY");
};

const secondsBetweenUpdates = function (d) {
  const now = dayjs();
  if (now.diff(d, "day") <= 3) return 30;
  // after the day before yesterday, we only show dates
  return 12 * 60 * 60;
};

const run = function ($elem) {
  const tss = $elem.attr("datetime");
  const d = dayjs(tss);
  const update = function () {
    const rel = fromNow(d);
    $elem.text(rel);
    setTimeout(update, secondsBetweenUpdates(d) * 1000);
  };
  update();
};

export default function relativeDates() {
  $("time.date[title][datetime]").each(function () {
    run($(this));
  });
}
